import io from 'socket.io-client';
import { logger } from 'packages';

export const registerLiveUpdates = ({ url, onConnect, onClientEvent }) => {
    let socket;
    try {
        socket = io.connect(url);
    } catch (e) {
        logger(e);
        return;
    }

    socket.on('connect', () => {
        try {
            onConnect(socket);
        } catch (e) {
            logger(e);
        }
    });

    socket.on('clientEvent', data => {
        try {
            onClientEvent(data);
        } catch (e) {
            logger(e);
        }
    });

    return () => socket.disconnect();
};
